export enum ZenithAppearance {
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  UPDATE = 'update'
}

export enum Icon {
  ADD = 'add',
  ERROR = 'error',
}